import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { Constants } from 'src/app/_consts/constants';
import { SharedService } from 'src/app/_shared/shared.service';
import { environment } from 'src/environments/environment';
import { SInputComponent } from '../comps/s-input/s-input.component';
import { SSelectComponent } from '../comps/s-select/s-select.component';
import { STableComponent } from '../comps/s-table/s-table.component';
import { Fce } from '../fce';
import { HttpPlus } from '../http-plus';
import dbFields from './db-fields';

@Component({
  selector: 'app-db',
  templateUrl: './db.component.html',
  styleUrls: ['./db.component.scss'],
  imports: [CommonModule, TranslateModule, NgbModule, STableComponent, SSelectComponent, SInputComponent]
})
export class DbComponent implements OnInit {

  @ViewChild('table', { static: false }) table: STableComponent;
  @Input() onlyTable = null
  @Input() hideCreate: boolean = false
  @Input() disabled: boolean = false
  @Output() onChange = new EventEmitter();

  tables = Constants.DB_EDITABLE_TABLES
  selectedTable: string = null
  cols = [];
  refreshUrl = "db/list";
  idPrefix = "id";
  extra: any
  primaryKeys = []

  constructor(public shared: SharedService, private http: HttpPlus) {
  }

  ngOnInit(): void {
    if (this.shared.rightsAll?.[Constants.MOD_BASE]?.dbTables) {
      this.tables = Constants.DB_EDITABLE_TABLES.filter(t => this.shared.rightsAll[Constants.MOD_BASE].dbTables.includes(t))
    }

    if (this.onlyTable) {
      this.selectedTable = this.onlyTable
    } else if (this.shared.storageGet("last_db_table") && this.tables.includes(this.shared.storageGet("last_db_table")))
      this.selectedTable = this.shared.storageGet("last_db_table")
    else
      this.selectedTable = this.tables[0]

    if (!this.tables.includes(this.selectedTable)) {
      this.selectedTable = null;
    }
    if (this.tables.length == 0) {
      this.shared.warning("You don't have rights to edit DB tables")
    }

    this.setExtra()
  }

  setExtra() {
    this.extra = { firstLoad: this.extra?.table != this.selectedTable, table: this.selectedTable }
  }

  tableOption = (item) => {
    return this.shared.t(`table_${item}`)
  }

  tableChange() {
    this.setExtra()
    if (this.selectedTable) {
      requestAnimationFrame(() => {
        this.table.cancelFilters(false)
        this.table.refresh(true)
      })
      if (!this.onlyTable)
        this.shared.storageSet("last_db_table", this.selectedTable)
    }
  }

  onResponse(response) {
    if (!response || !response.cols || !response.foreign_keys)
      return

    //Sort foreign keys
    Object.entries(response.foreign_keys).forEach(this.processForeign);
    Object.entries(response.choices).forEach(this.processForeign);

    this.cols = response.cols.map(c => {
      const type = c.Type.split("(")[0].toUpperCase()
      const col: any = {
        attr: c.Field,
        type: (Constants.DB_SPECIAL_TYPES[c.Field] || dbFields[type] || 'text'),
        disabledAll: Constants.DB_DISABLED_ATTRS.includes(c.Field) || this.disabled,
        disabledExisting: false,
      }
      col.required = c.Null == "NO" && col.type != "bool"

      if (c.Field.startsWith(`${this.idPrefix}_`) || c.Field == this.idPrefix) {
        if (c.Extra.includes("auto_increment"))
          col.disabledAll = true
        else if (!Constants.DB_ALLOW_ID_ATTRS.includes(c.Field))
          col.disabledExisting = true
      }
      if (c.Field.endsWith("_by")) {
        col.attr += "_name"
        col.type = "text"
      }
      switch (col.type) {
        case 'select':
          if (response.enums[col.attr]) {
            col.bindLabel = null
            col.bindValue = null
            col.options = response.enums[col.attr]
          }
          else if (response.foreign_keys[col.attr]) {
            col.bindLabel = "concat"
            col.bindValue = response.foreign_keys[col.attr].db_ref_column
            col.options = response.foreign_keys[col.attr].values
          }
          break;
        case 'multi_select':
          if (Constants.DB_MULTI_SELECTS[col.attr] && response.choices[Constants.DB_MULTI_SELECTS[col.attr]]) {
            col.bindLabel = "concat"
            col.bindValue = response.choices[Constants.DB_MULTI_SELECTS[col.attr]].db_ref_column
            col.options = response.choices[Constants.DB_MULTI_SELECTS[col.attr]].values
          }
          col.type = 'select'
          col.multiple = true
          break;
      }
      return col
    })
    this.primaryKeys = response.cols.filter(c => {
      return c.Key == "PRI"
    }).map(c => c.Field)

    if (Constants.DB_TABLES_ONLY_NEW.includes(this.selectedTable))
      response.rows.forEach(r => {
        r.disabled = true
      });

    this.table.rows = Fce.convertToStaticArray(response.rows, this.cols, this.shared.transService);
    console.log(response, this.cols)
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  processForeign([i, key]: any) {
    key.values.forEach(val => {
      val.concat = ""
      for (const key in val) {
        if (Constants.DB_CONCAT_FOREIGN.includes(key) && !Fce.empty(val[key]))
          val.concat += (val.concat.length > 0 ? ", " : "") + val[key]
      }
    });
    key.values.sort((a, b) => a.concat.localeCompare(b.concat))
  }

  addRow() {
    if (this.table.rowsOrig.find(r => r.isNew)) {
      this.shared.warning("finish_editing_first");   this.table.scrollToNew();
      return;
    }
    const row: any = { isNew: true, trClass: 'row-highlight' }
    if (this.selectedTable == "news")
      row.version = environment.version
    this.table.addRow(row, this.table.rows.length, true, true)
  }

  async saveRow(row, rowRaw) {
    for (const col of this.cols) {
      if (col.required && Fce.empty(rowRaw[col.attr]) && !col.disabledAll) {
        this.shared.warning("required_fields_not_filled");
        return;
      }
    }

    const params = {
      row: Fce.convertForServer({ ...rowRaw }),
      table: this.selectedTable,
      cols: this.cols,
      primary_keys: this.primaryKeys
    }
    console.log(params)
    const response: any = await this.http.put(`db/row`, params)
    if (response) {
      this.shared.success();
      if (rowRaw.copy) {
        this.table.refresh(true);
      } else {
        rowRaw.isNew = false;
        const tmp = Fce.convertForClient({ ...response.row });
        const tmp2 = Fce.convertToStatic(response.row, this.cols, this.shared.transService);
        for (const key in tmp) {
          rowRaw[key] = tmp[key];
          row[key] = tmp2[key];
        }
      }
      this.onChange.emit();
    }
  }

  copyRow(row) {
    if ( this.table.rowsOrig.find(r => r.isNew)) {
      this.shared.warning("finish_editing_first");
      this.table.scrollToNew();
      return;
    }

    const copy = Fce.copy(row);
    copy.copy = true;
    copy.isNew = true;
    copy.trClass = 'row-highlight';
    this.primaryKeys.forEach(k => {
      delete copy[k];
    })
    delete copy.created_at
    delete copy.created_by
    delete copy.updated_at
    delete copy.updated_by
    //console.log(copy);
    this.table.addRow(copy)
    this.table.scrollToNew();
  }


  deleteRow(row) {
    this.shared.modalYesNo("are_you_sure", null, async () => {

      const params = {
        row: Fce.convertForServer({ ...row }),
        table: this.selectedTable,
        primary_keys: this.primaryKeys
      }
      console.log("PARAMS", params)
      await this.http.post(`db/deleteRow`, params)
      this.shared.info("Deleted");
      this.table.refresh(true);
      this.onChange.emit();
    })
  }

  cancelRow(index) {
    this.table.removeRow(index)
  }

}
